export default "__VITE_ASSET__SkQ93iMS__"